import { useParams } from "react-router";
import { useMemo } from "react";
export function useTypedParams(route) {
    const params = useParams();
    return useMemo(() => route.$deserializeParams(params), [route, params]);
}
